import { Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLink = styled(MuiLink)(({ theme, variant }) => ({
  color: theme.palette.primary.main,
  textDecorationColor: theme.palette.primary.main,

  '&:hover': {
    color: theme.palette.primary.dark,
    textDecorationColor: theme.palette.primary.dark,
  },

  '&:active': {
    color: theme.palette.custom.primaryDark2,
    textDecorationColor: theme.palette.custom.primaryDark2,
  },

  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: theme.palette.primary.light,
    outlineOffset: '2px',
  },

  ...(variant === 'body2' && {
    fontSize: '14px',
    fontWeight: 400,
  }),
}));
